import React, {createContext, useReducer} from 'react'

export const AppContext = createContext();

const initialState = {
  availableWorkshops: [
    // {
    //   name: 'Meditation Session 1',
    //   startTimeHour: 10,
    //   startTimeMinute: 0,
    //   endTimeHour: 22,
    //   endTimeMinute: 0,
    //   durationInMinute: 60,
    //   uid: '12312312312',
    //   imgUrl: 'https://cdn.vectorstock.com/i/1000x1000/26/74/green-chairs-sit-around-table-view-from-above-vector-33562674.webp',
    //   numberOfChairs: 6
    // },{
    //   name: 'Meditation Session 2',
    //   startTimeHour: 10,
    //   startTimeMinute: 0,
    //   endTimeHour: 22,
    //   endTimeMinute: 0,
    //   durationInMinute: 60,
    //   uid: '123123312312',
    //   imgUrl: 'https://cdn.vectorstock.com/i/1000x1000/26/74/green-chairs-sit-around-table-view-from-above-vector-33562674.webp',
    //   numberOfChairs: 6
    // },
  ],
  selectedWorkshop: null,
  allBookings: [],
  bookingToEdit: null,
  masterReset: 0,
  currentUser: null,
  currentPlan: null
}

const reducer = (state, action) => {
  return {...state, ...action}
};

export const AppContextProvider = props => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <AppContext.Provider value={{state, dispatch}}>
      {props.children}
    </AppContext.Provider>
  )
};
